import {Component, OnInit} from '@angular/core';
import {NavigationItem} from 'features/core/shared/dto/navigation/navigation-item';
import {ObjectBaseModeComponent} from 'features/core/shared/object/mvs-object-base/object-base-mode.component';

/**
 * Base-mode component of the Provisionssatz OBC (layer 2 of the three-layer pattern).
 *
 * Exact shape of `cp-provision-agent-object/view/base/cp-provision-agent-base.component.ts`: a
 * component WITHOUT a template of its own (`template: ''`) that declares only the
 * `navigationItems`; `full` and `side` inherit from it and render one shared component per item.
 * Because the class is never rendered itself it deliberately has NO .html/.scss.
 *
 * `ObjectBaseModeComponent` subscribes to `?navItem=` / `?sideNavItem=` on its own, so nothing has
 * to be rebuilt here.
 *
 * The six navigation items follow the entity's own structure: identity first, then the money, then
 * the liability bookkeeping, then the two neighbours a caseworker jumps to (the contract behind
 * the Satz and its bookings), and Storno last because it is the terminal state.
 */
@Component({
    selector: 'cp-provision-contract-agent-base',
    template: '',
    standalone: false
})
export class CpProvisionContractAgentBaseComponent extends ObjectBaseModeComponent implements OnInit {

    /**
     * Navigation items of the Provisionssatz. `action` (not `route`) is the key — it is matched
     * against `?navItem=`.
     */
    navigationItems: NavigationItem[] = [
        {
            label: 'Basisdaten',
            action: 'baseData',
            tooltip: 'Zuordnung des Provisionssatzes: Provisionszeile, Abrechnungskonto, '
                + 'Beraterrolle, Provisionsart und Herkunft',
            icon: 'fa-regular fa-id-card',
            toggleable: false,
            default: true
        },
        {
            label: 'Beträge',
            action: 'amounts',
            tooltip: 'Berechneter Betrag, manueller Overwrite sowie Rücklage- und Zielbeträge',
            icon: 'fa-regular fa-euro-sign',
            toggleable: false,
            default: false
        },
        {
            label: 'Haftung',
            action: 'liability',
            tooltip: 'Haftungstyp, Haftungszeitraum und die Beträge in und aus der Haftung',
            icon: 'fa-regular fa-shield-halved',
            toggleable: false,
            default: false
        },
        {
            label: 'Vertrag',
            action: 'contract',
            tooltip: 'Vertrag und Provisionszeile, zu denen dieser Provisionssatz gehört',
            icon: 'fa-regular fa-file-contract',
            toggleable: false,
            default: false
        },
        {
            label: 'Buchungen',
            action: 'transactions',
            tooltip: 'Vertragsseitige Buchungen zu diesem Provisionssatz',
            icon: 'fa-regular fa-right-left',
            toggleable: false,
            default: false
        },
        {
            label: 'Storno',
            action: 'cancellation',
            tooltip: 'Stornodatum und der zum Stornozeitpunkt eingefrorene Haftungsbetrag',
            icon: 'fa-regular fa-ban',
            toggleable: false,
            default: false
        }
    ];

    ngOnInit() {
        super.ngOnInit();
        this.initialized = true;
    }

}
